//import { updateField } from 'vuex-map-fields';
export default {
    updateAdminData(state, data) {
        state.admins = data
    },
    updateClientData(state, data) {
        state.clients = data
    },
    updateConsultantData(state, data) {
        state.consultants = data
    },
    updateIndex(state, index) {
        state.index = index
    },
    updateUser(state, data) {
        state.user = data;
    },
    // Admin
    updateAdminCount(state, data) {
        state.adminCount = data;
    },
    updateAdminCurrent(state, data) {
        state.adminCurrent = data;
    },
    updateAdminLimit(state, data) {
        state.adminLimit = data;
    },
    updateAdminSearch(state, data) {
        state.adminSearch = data;
    },
    updateAdminBlock(state, data) {
        state.adminBlock = data;
    },
    updateAdminSampleCsv(state, data) {
        state.adminSampleCsv = data;
    },
    // Client
    updateClientCount(state, data) {
        state.clientCount = data;
    },
    updateClientCurrent(state, data) {
        state.clientCurrent = data;
    },
    updateClientLimit(state, data) {
        state.clientLimit = data;
    },
    updateClientSearch(state, data) {
        state.clientSearch = data;
    },
    updateClientBlock(state, data) {
        state.clientBlock = data;
    },
    updateClientSubtype(state, data) {
        state.clientSubtype = data;
    },
    updateClientSampleCsv(state, data) {
        state.clientSampleCsv = data;
    },
    // Consultant
    updateConsultantCount(state, data) {
        state.consultantCount = data;
    },
    updateConsultantCurrent(state, data) {
        state.consultantCurrent = data;
    },
    updateConsultantLimit(state, data) {
        state.consultantLimit = data;
    },
    updateConsultantSearch(state, data) {
        state.consultantSearch = data;
    },
    updateConsultantBlock(state, data) {
        state.consultantBlock = data;
    },
    updateConsultantSampleCsv(state, data) {
        state.consultantSampleCsv = data;
    },
    resetState(state, data) {
        state.admins = [];
        state.clients = [];
        state.consultants = [];
        state.index = -1;
        state.user = null;
    },
}